import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

// ✅ push/replace 에러 삼키기 (Redirected 포함)
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(() => {});
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(() => {});
};



const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/product/:tab?",
    name: "Product",
    component: () => import("../views/Product.vue"),
    meta: { permissionKey: "product" },
  },
  {
    path: "/billetingredcriteria",
    name: "BilletIngredCriteria",
    component: () => import("../components/BilletIngredCriteria.vue"),
    meta: { permissionKey: "billetIngredCriteria" },
  },
  {
    path: "/billetarrival",
    name: "BilletArrival",
    component: () => import("../components/BilletArrival.vue"),
    meta: { permissionKey: "billetArrival" },
  },
  {
    path: "/incominginsp",
    name: "IncomingInsp",
    component: () => import("../components/IncomingInsp.vue"),
    meta: { permissionKey: "incomingInsp" },
  },
  {
    path: "/mold",
    name: "MoldManage",
    component: () => import("../components/MoldManage.vue"),
    meta: { permissionKey: "mold" },
  },
  {
    path: '/compRegist/:tab?',
    name: "CompRegist",
    component: () => import("../views/CompRegistView.vue"),
    meta: { permissionKey: "compRegist" },
  },
  {
    path: "/dataread",
    name: "DataRead",
    component: () => import("../views/DataView.vue"),
    meta: { permissionKey: "dataRead" },
  },
  {
    path: "/adminpage",
    name: "AdminPage",
    component: () => import("../views/AdminPageView.vue"),
  },
  {
    path: "/sensorTolerance",
    name: "SensorTolerance",
    component: () => import("../views/TolerancePageView.vue"),
    meta: { permissionKey: "sensorTolerance" },
  },
  {
    path: "/moldRegist",
    name: "MoldRegist",
    component: () => import("../views/MoldRegist.vue"),
    meta: { permissionKey: "moldRegist" },
  },
  {
    path: "/shipmentSchedule",
    name: "ShipmentSchedule",
    component: () => import("../views/ShipmentSchedule.vue"),
    meta: { permissionKey: "customerOrder" },
  },
  {
    path: "/customerOrder",
    name: "CustomerOrderRegist",
    component: () => import("../views/CustomerOrderRegist.vue"),
    meta: { permissionKey: "customerOrder" },
  },
  {
    path: "/extrusion",
    name: "ExtrusionInfo",
    component: () => import("../views/ExtrusionInfo.vue"),
    meta: { permissionKey: "extrusion" },
  },
  {
    path: "/workConditionLayout",
    component: () => import("../views/WorkConditionLayout.vue"),
    meta: { permissionKey: "workCondition" },
    children: [
      {
        path: "",
        name: "WorkConditionList",
        component: () => import("../components/WorkConditionList.vue"),
      },
      {
        path: "write",
        name: "WorkConditionWrite",
        component: () => import("../components/WorkConditionWrite.vue"),
      },
      {
        path: ":id",
        name: "WorkConditionDetail",
        component: () => import("../components/WorkConditionDetail.vue"),
        props: true,
      },
      {
        path: "edit/:id",
        name: "WorkConditionEdit",
        component: () => import("../components/WorkConditionEdit.vue"),
        props: true,
      },
    ],
  },
  {
    path: "/productionOrderLayout",
    component: () => import("../views/ProductionOrderLayout.vue"),
    meta: { permissionKey: "productionOrder" },
    children: [
      {
        path: "",
        name: "ProductionOrderList",
        component: () => import("../components/ProductionOrderList.vue"),
      },
      {
        path: "write",
        name: "ProductionOrderWrite",
        component: () => import("../components/ProductionOrderWrite.vue"),
      },
      {
        path: ":id",
        name: "ProductionOrderDetail",
        component: () => import("../components/ProductionOrderDetail.vue"),
        props: true,
      },
      {
        path: "edit/:id",
        name: "ProductionOrderEdit",
        component: () => import("../components/ProductionOrderEdit.vue"),
        props: true,
      },
    ],
  },
  {
    path: "/heatTreatmentLayout",
    component: () => import("../views/HeatTreatmentLayout.vue"),
    meta: { permissionKey: "heatTreatment" },
    children: [
      {
        path: "",
        name: "HeatTreatmentList",
        component: () => import("../components/HeatTreatmentList.vue"),
      },
    ],
  },
  {
    path: "/extrusionCompLayout",
    component: () => import("../views/ExtrusionCompLayout.vue"),
    meta: { permissionKey: "extrusionComp" },
    children: [
      {
        path: "",
        name: "ExtrusionCompList",
        component: () => import("../components/ExtrusionCompList.vue"),
      },
    ],
  },
  {
    path: "/heatTreatWaitLayout",
    component: () => import("../views/HeatTreatWaitLayout.vue"),
    meta: { permissionKey: "heatTreatWait" },
    children: [
      {
        path: "",
        name: "HeatTreatWaitList",
        component: () => import("../components/HeatTreatWaitList.vue"),
      },
    ],
  },
  {
    path: "/productWarehouseLayout",
    component: () => import("../views/ProductWarehouseLayout.vue"),
    meta: { permissionKey: "productWarehouse" },
    children: [
      {
        path: "",
        name: "ProductWarehouseList",
        component: () => import("../components/ProductWarehouseList.vue"),
      },
    ],
  },
  {
    path: "/productShipmentLayout",
    component: () => import("../views/ProductShipmentLayout.vue"),
    meta: { permissionKey: "productShipment" },
    children: [
      {
        path: "",
        name: "ProductShipmentList",
        component: () => import("../components/ProductShipmentList.vue"),
      },
    ],
  },
  {
    path: "/orderComp",
    name: "OrderComp",
    component: () => import("../components/OrderComp.vue"),
  },
  {
    path: "/logPage",
    name: "logPage",
    component: () => import("../views/ReadLogView.vue"),
  },
  {
    path: "/login",
    name: "LoginPage",
    component: () => import("../views/LoginView.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.afterEach(() => {
  const highlightId = sessionStorage.getItem('highlightRowId');
  if (!highlightId) return;
  sessionStorage.removeItem('highlightRowId');

  let attempts = 0;
  const tryHighlight = () => {
    const tr = document.querySelector(`tr[data-row-id="${highlightId}"]`);
    if (tr) {
      tr.scrollIntoView({ behavior: 'smooth', block: 'center' });
      tr.style.transition = 'none';
      tr.style.backgroundColor = '#ff749b';
      setTimeout(() => {
        tr.style.transition = 'background-color 1.5s ease';
        tr.style.backgroundColor = '';
      }, 500);
      return;
    }
    if (++attempts < 30) setTimeout(tryHighlight, 200);
  };
  setTimeout(tryHighlight, 200);
});

router.beforeEach((to, from, next) => {
  const userStr = sessionStorage.getItem("userDvi");
  const user = userStr ? JSON.parse(userStr) : null;
  const loggedIn = !!(user && user.token);
  const isAdmin = !!(user?.roles?.includes("ROLE_ADMIN"));

  // 1) 공개 페이지 (로그인 불필요)
  const publicPages = ["/login"];
  if (publicPages.includes(to.path)) return next();

  // 2) 로그인 필요
  if (!loggedIn) {
    alert("로그인이 필요한 서비스입니다.");
    return next("/login");
  }

  // 3) Admin 전용 페이지
  const adminOnlyPaths = ["/adminpage", "/logPage"];
  if (adminOnlyPaths.includes(to.path)) {
    if (!isAdmin) {
      alert("접근 불가능한 페이지입니다.");
      return next(false);
    }
    return next();
  }

  // 4) ROLE_ADMIN은 모든 페이지 접근 허용
  if (isAdmin) return next();

  // 5) permissionKey가 있는 페이지는 권한 확인 (구 배열 / 신 객체 포맷 모두 지원)
  const permissionKey = to.matched.find(r => r.meta && r.meta.permissionKey)?.meta?.permissionKey;
  if (permissionKey) {
    let permissions;
    try { permissions = JSON.parse(user.permissions || '{}'); } catch { permissions = {}; }
    const hasAccess = Array.isArray(permissions)
      ? permissions.includes(permissionKey)
      : Object.prototype.hasOwnProperty.call(permissions, permissionKey);
    if (!hasAccess) {
      alert("접근 불가능한 페이지입니다.");
      return next(false);
    }
  }

  next();
});
  

export default router;
